import BaseEventModel from '../events/base-event-model';
import { IHttp } from '../http';
import { IEventSender } from './event-sender';

export class PostRequestEventSender implements IEventSender {
  private readonly http: IHttp;
  private readonly cdn: string;

  /**
   * Initializes a new instance of the event sender that utilizes HTTP POST request to send events.
   */
  constructor(cdn: string, http: IHttp) {
    this.http = http;
    this.cdn = cdn;
  }

  public async send(event: BaseEventModel): Promise<void> {
    await this.http.post(this.cdn, event);
  }
}
